import { render, staticRenderFns } from "./notationDetail.vue?vue&type=template&id=a9cdb37a&scoped=true"
import script from "./notationDetail.vue?vue&type=script&lang=js"
export * from "./notationDetail.vue?vue&type=script&lang=js"
import style0 from "./notationDetail.vue?vue&type=style&index=0&id=a9cdb37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cdb37a",
  null
  
)

export default component.exports